import React from 'react';
import { useTranslation } from 'react-i18next';

export interface GameKeyTableViewSwitcherProps {
  groupBy: string;
  setGroupBy: (value: 'total' | 'workflow') => void;
}

function GameKeyTableViewSwitcher({ groupBy, setGroupBy }: GameKeyTableViewSwitcherProps) {
  const { t } = useTranslation();
  return (
    <>
      <button
        className={`btn btn-${
          groupBy === 'total' ? 'primary' : 'default'
        } btn-outline r-corners-left`}
        onClick={() => setGroupBy('total')}
        title={t('Group by game')}
      >
        {t('Total')}
      </button>
      <button
        className={`btn btn-${
          groupBy === 'workflow' ? 'primary' : 'default'
        } btn-outline r-corners-right`}
        onClick={() => setGroupBy('workflow')}
        title={t('Group by workflow')}
      >
        {t('By workflow')}
      </button>
    </>
  );
}

export default GameKeyTableViewSwitcher;
